// extracted by mini-css-extract-plugin
export default {"container":"style_container__vmAF7","title":"style_title__I-7AB","animation":"style_animation__HJA2I"};